import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-agents-iframe',
  standalone: true,
  template: `
    <div class="w-full h-full border-none overflow-hidden" style="min-height: calc(100vh - 100px);">
      <iframe
        [src]="safeUrl"
        class="border-none"
        allow="autoplay; camera; microphone; fullscreen; display-capture; clipboard-read; clipboard-write"
      ></iframe>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AgentsIframeComponent {
  private sanitizer = inject(DomSanitizer);
  public safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'https://agents-paymefy.lovable.app/agents',
  );
}
